import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router-dom';

const CardListItem = ({
  href,
  children,
  className,
  variant = 'default',
  ...props
}) => {
  const Component = href ? Link : 'div';

  return (
    <Component
      to={href}
      className={clsx(
        'relative flex-1 flex justify-start items-center transition-colors bg-white',
        {
          'hover:bg-gray-50': !!href,
          'font-semibold p-0 border-b border-gray-100 mt-4':
            variant === 'header',
          'border-b border-gray-100': variant === 'default',
        },
        className,
      )}
      {...props}
    >
      {children}
    </Component>
  );
};

export default CardListItem;
